"use client";

import ArrowsLeftRightIcon from "@/assets/icons/arrows-left-right.svg";
import LikeIcon from "@/assets/icons/like.svg";
import LikedIcon from "@/assets/icons/liked.svg";
import ChatIcon from "@/assets/icons/chat.svg";
import XIcon from "@/assets/icons/logo-twitter.svg";
import { FeedPostDto } from "@/api/posts/types";
import useMe from "@/shared/hooks/useMe";
import { FooterAction } from "./FooterAction";
import { twMerge } from "tailwind-merge";
import FeedRepostModal from "../Modals/FeedRepostModal";
import config from "@shared/config/client";
import { buildRetweetUrl } from "@/shared/utilities";
import { Dispatch, SetStateAction, useState } from "react";
import usePostLike from "../../Likes/hooks/usePostLike";
import { useQuery } from "@tanstack/react-query";
import commentsApi from "@/api/comments/feed/client";

export interface Props {
  feedPost: FeedPostDto;
  setShowReply?: Dispatch<SetStateAction<boolean>>;
  disableComment?: boolean;
}

export default function FeedPostFooter({
  feedPost,
  setShowReply,
  disableComment,
}: Props) {
  const { me } = useMe();
  const { isLikedByMe, toggleLike, likeCount } = usePostLike({
    postId: feedPost.id,
    user: me,
  });

  const { data: commentCount } = useQuery({
    queryKey: ["feed-comment-count", feedPost.id],
    queryFn: () => commentsApi.getPostCommentCount(feedPost.id),
  });

  const [isFeedRepostModalOpen, setIsFeedRepostModalOpen] = useState(false);

  const twitterText =
    `${feedPost.text} Check out full post on Endemic:`.replace(" ", "%20");

  const retweetUrl = buildRetweetUrl(
    twitterText,
    `${config.url}/feed/${feedPost.id}`,
  );

  return (
    <ul className="flex justify-start gap-4">
      <FeedRepostModal
        isOpen={isFeedRepostModalOpen}
        onClose={() => setIsFeedRepostModalOpen(false)}
        feedPost={feedPost.repost || feedPost}
      />
      {!disableComment ? (
        <FooterAction
          label={commentCount || 0}
          icon={
            <ChatIcon
              className={twMerge(
                "w-6 h-6 endemic:fill-white",
                !me && "fill-endemicGray-700 endemic:opacity-60",
                !!me && "fill-red",
              )}
            />
          }
          color={"red"}
          onClick={() => setShowReply!((prevShowReply) => !prevShowReply)}
        />
      ) : null}
      <FooterAction
        label={likeCount?.toString() || "0"}
        icon={
          isLikedByMe ? (
            <LikedIcon
              className={twMerge(
                "w-6 h-6 endemic:fill-white",
                !me && "fill-endemicGray-700 endemic:opacity-60",
                !!me && "fill-red",
              )}
            />
          ) : (
            <LikeIcon
              className={twMerge(
                "w-6 h-6 endemic:fill-white",
                !me && "fill-endemicGray-700 endemic:opacity-60",
                !!me && "fill-red",
              )}
            />
          )
        }
        color={"red"}
        onClick={toggleLike}
      />
      <FooterAction
        label={feedPost.numberOfReposts || 0}
        icon={
          <ArrowsLeftRightIcon
            className={twMerge(
              "w-6 h-6 endemic:fill-white",
              !me && "fill-endemicGray-700 endemic:opacity-60",
              me && "fill-red",
            )}
          />
        }
        color={"red"}
        onClick={() => setIsFeedRepostModalOpen(true)}
      />
      <FooterAction
        label={"Re-post on X"}
        href={retweetUrl}
        target="_blank"
        labelClassName="hidden md:visible"
        icon={
          <XIcon
            className={twMerge(
              "w-6 h-6 endemic:fill-white",
              !me && "fill-endemicGray-700 endemic:opacity-60",
              !!me && "fill-primary",
            )}
          />
        }
        color={"primary"}
        onClick={() => {}}
      />
    </ul>
  );
}
